import React from 'react';
import { Card, Badge, Dropdown } from 'react-bootstrap';
import '../styles/queriesManagement.css';

const QueryCard = ({ query, isSelected, onClick, onAssign, teams, readOnly = false }) => {
    if (!query) return null;

    const getStatusBadge = (status) => {
        const variants = {
            pending: 'warning',
            assigned: 'info',
            resolved: 'success'
        };
        return <Badge bg={variants[status] || 'secondary'}>{status || 'pending'}</Badge>;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        if (diffMins < 60) {
            return `${diffMins}m ago`;
        } else if (diffHours < 24) {
            return `${diffHours}h ago`;
        } else if (diffDays < 7) {
            return `${diffDays}d ago`;
        } else {
            return date.toLocaleDateString();
        }
    };

    const truncateText = (text, maxLength = 80) => {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    return (
        <Card 
            className={`query-card mb-3 ${isSelected ? 'selected' : ''}`}
            onClick={onClick}
            style={{ cursor: 'pointer' }}
        >
            <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="flex-grow-1">
                        <div className="d-flex align-items-center mb-1">
                            <strong className="query-from me-2">
                                {query.from?.name || query.from?.email || 'Unknown'}
                            </strong>
                            {getStatusBadge(query.status)}
                            {query.assignedTo && (
                                <Badge bg="secondary" className="ms-2">
                                    {query.assignedTo}
                                </Badge>
                            )}
                        </div>
                        <div className="query-subject mb-1">
                            {truncateText(query.subject, 60)}
                        </div>
                        <div className="query-preview text-muted">
                            {truncateText(query.body, 100)}
                        </div>
                    </div>
                    {!readOnly && (
                        <div className="query-actions ms-3">
                            <Dropdown onClick={(e) => e.stopPropagation()}>
                                <Dropdown.Toggle
                                    variant="link"
                                    size="sm"
                                    className="text-decoration-none"
                                >
                                    Assign
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {teams.map(team => (
                                        <Dropdown.Item
                                            key={team}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onAssign(query._id, team);
                                            }}
                                        >
                                            {team.charAt(0).toUpperCase() + team.slice(1)}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    )}
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <small className="text-muted">
                        {formatDate(query.receivedAt)}
                    </small>
                    {query.replies && query.replies.length > 0 && (
                        <Badge bg="light" text="dark" className="ms-2">
                            {query.replies.length} {query.replies.length === 1 ? 'reply' : 'replies'}
                        </Badge>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
};

export default QueryCard;
